import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  createTaxAndFeeSetting,
  deleteTaxAndFeeSetting,
  getTaxAndFeeSettings,
  updateTaxAndFeeSetting,
} from "../services/taxAndFeeService";
import { TaxAndFeeSetting } from "../types/admin";
import { ApiResponse } from "../types/common";

import {
  CreateTaxAndFeeRequest,
  UpdateTaxAndFeeRequest,
} from "../types/admin";

export const taxAndFeeKeys = {
  all: ["tax-and-fees"] as const,
  list: () => [...taxAndFeeKeys.all, "list"] as const,
  detail: (id: string) => [...taxAndFeeKeys.all, id] as const,
};

export const useTaxAndFeeSettings = (isActive?: boolean) => {
  return useQuery<ApiResponse<TaxAndFeeSetting[]>>({
    queryKey: [...taxAndFeeKeys.list(), isActive],
    queryFn: () => getTaxAndFeeSettings(isActive),
    staleTime: 30 * 1000,
  });
};

export const useTaxAndFeeMutations = () => {
  const queryClient = useQueryClient();

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: taxAndFeeKeys.list() });
  };

  const create = useMutation({
    mutationFn: (data: CreateTaxAndFeeRequest) =>
      createTaxAndFeeSetting(data),
    onSuccess: invalidate,
  });

  const update = useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateTaxAndFeeRequest }) =>
      updateTaxAndFeeSetting(id, data),
    onSuccess: invalidate,
  });

  const remove = useMutation({
    mutationFn: (id: string) => deleteTaxAndFeeSetting(id),
    onSuccess: invalidate,
  });

  return { create, update, remove };
};

